import { action, observable } from 'mobx';
import { useStaticRendering } from 'mobx-react';
import ApiCore from './ApiCore';

const isServer = !process.browser;
useStaticRendering(isServer);

class GeneralStore {
  @observable loadingScreen = false;

  @observable homePage = {};

  @observable contactPage = {};

  @observable educationPage = {};

  @observable businessPage = {};

  @observable showMore = false;

  /**
   *
   * @param {string} observable
   * @param {boolean} state
   */
  @action toggleBoolean(observableKey, state) {
    this[observableKey] = state;
  }

  /**
   * calls from _app.js
   * populates the basic pages if one of them is empty
   */
  @action index() {
    if (
      !this.homePage.acf
      || !this.contactPage.acf
      || !this.educationPage.acf
      || !this.businessPage.acf) {
      return new Promise((resolve) => {
        ApiCore.get('/wp/v2/pages')
          .then((response) => {
            // Finds hardCoded IDs and sets accordingly
            this.homePage = response.data.find(page => page.id === 4913);
            this.contactPage = response.data.find(page => page.id === 4906);
            this.educationPage = response.data.find(page => page.id === 4860);
            this.businessPage = response.data.find(page => page.id === 4854);
          })
          .then(() => resolve());
      });
    }

    return Promise.reject();
  }
}

let generalStore = null;

export default function initializeGeneralStore(initialData) {
  if (isServer) {
    return new GeneralStore(isServer, initialData);
  }

  if (generalStore === null) {
    generalStore = new GeneralStore(isServer, initialData);
  }
  return generalStore;
}
